import { get } from '@/utils/api';
import { useQuery } from '@tanstack/react-query';
import { B2bStats, featureKeys, featurePath } from '.';

const ONE_HOUR = 1000 * 60 * 60;

// The stats endpoint returns a top-level `{ all_nbe, b2b_team, meta }` body
// (no `{ data }` envelope), so get()'s passthrough returns it as-is.
export const fetchB2bStats = () =>
  get<B2bStats>(`${featurePath}/stats`, undefined, { skipErrorToast: true });

export const useB2bStats = () =>
  useQuery({
    queryKey: featureKeys.stats(),
    queryFn: fetchB2bStats,
    refetchInterval: ONE_HOUR,
    refetchOnWindowFocus: true,
    throwOnError: false,
  });
